<template>
  <div class="aside">
    <div class="list-group list-group-root well ml-0">

      <li
        is="UserButton"
        v-for="(user, index) in users"
        v-bind:key="$filters.cleanId(user.id)"
        v-bind:index="index"
        v-bind:name=user.userName
        v-bind:user=user
      ></li>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import UserButton from './UserButton.vue'
Vue.use(UserButton)
import GroupList from './GroupList.vue'
Vue.use(GroupList)
export default {
  name: 'AsideUserList',
  props: {
    msg: String
  },
  components: {
    UserButton, GroupList
  },
  data() {
    return {
      show_list: true,
      users_: [
        {
            id: 1,
            name: "User1",
            is_group: false,
        },
        {
            id: 2,
            name: "User2",
            is_group: false,
        },
        {
            id: 3,
            name: "User2",
            is_group: false,
        },
        {
            id: 4,
            name: "User2",
            is_group: false,
        },
      ]
    }
  },
  methods: {
    switchUser(user) {
      this.$store.commit('switch_user', user)
      this.$store.dispatch('loadUserData')
      
    },
  },
  computed: {
    users() {
      if (this.$store.state.user_list) {
          // eslint-disable-next-line
          console.log(this.$store.state.user_list.users);
          return this.$store.state.user_list.users
      } else {
          return this.users_
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .aside {
    overflow-y: auto;
    max-height: 100%;
  }
</style>
